import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "up-action-bar",
  templateUrl: "./action-bar.component.html",
  styleUrls: ["./action-bar.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ActionBarComponent implements OnInit {
  @Input() backUrl!: string[];
  @Input() pageTitle!: string;
  @Input() isList: boolean = true;
  @Input() isBusy: boolean = false;
  @Input() showBackButton: boolean = true;
  @Input() showButton: boolean = true;
  @Input() nextButton: boolean = false;
  @Input() eventOnBack: boolean = false;
  @Input() buttonText?: string;
  @Input() buttonIcon?: string;

  @Output() buttonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() backClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(private _router: Router) {}

  ngOnInit(): void {}

  buttonClicked(): void {
    this.buttonClick.emit();
  }

  backClicked(): void {
    if (this.eventOnBack) this.backClick.emit();
    else this._router.navigate(this.backUrl);
  }
}
